import { Table } from "@/features/Table";
import { useBulkDeleteControls } from "@/features/Edit/useBulkDeleteControls";
import { type A6Transaction, porfolios_columns } from "./columns";
import {
  type FilterA6TransactionsSchema,
  FilterA6Transactions,
} from "./filter";

const client = "a6";
const table_name = "a6_transactions";

export const A6TransactionsTable = () => {
  const { selectionActions, modal } = useBulkDeleteControls<A6Transaction>({
    client,
    table_name,
    resourceLabel: "Transactions",
  });

  return (
    <>
      <Table<A6Transaction, FilterA6TransactionsSchema>
        label="Transactions"
        client={client}
        table_name={table_name}
        columns={porfolios_columns}
        filter={<FilterA6Transactions />}
        actions={[
          {
            label: "actions.new",
            route: `${client}/${table_name}/new`,
          },
        ]}
        enableRowSelection
        selectionActions={selectionActions}
      />
      {modal}
    </>
  );
};
